import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=156d5083&"
import script from "./banner.js?vue&type=script&lang=js&"
export * from "./banner.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports